import { ValidationGroup } from "devextreme-react/validation-group";
import React, { FC, useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { FormProaFEPresenter } from "@presenters/screens/form-proa-fe.presenter";
import { String, Utilities } from "@utils";
import GeneralData from "./general-data/general-data";
import MRIIndicators from "./general-data/mri-indicators";
import storeContext from "@/context/store-context";
import Loader from '@/components/ui/aea-fade-loader/Loader';
import styles from "../form-proa-subproject-fe.module.scss";
import AEATitle from "@/components/ui/aea-title/aea-title";

export interface IObjetiveFE {
  step1?: any;
  step4: any;
  step4MRI: any;
  index: number;
  dataColumns: any;
  subventionCodeId: number;
  startDate: any;
  endDate: Date;
  switchForm?: boolean;
  alertEndDate: boolean;
  setStep4(step4: any): void;
  setStep4MRI(step4MRI: any): void;
  getWarningMsg?(): void;
  handleSwitch?(): void;
}

const { StoreContext } = storeContext;

const ObjetivesFE: FC<IObjetiveFE> = (props) => {
  const [objetives, setObjetives] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const context = useContext(StoreContext);

  const [mriData, setMriData] = useState(null);
  const [stepData, setStepData] = useState(null);
  const [showAlerts, setShowAlerts] = useState(false);

  let validationGroup: ValidationGroup;
  const presenter = new FormProaFEPresenter({
    state: {
      objetives: objetives,
      step4Data: props.step4,
      subventionCodeId: props.subventionCodeId,
      readOnly: readOnly,
      stepMriData: props.step4MRI,
      setObjetives: setObjetives,
      setStep4Data: props.setStep4,
      setReadOnly: setReadOnly,
      setStepMriData: props.setStep4MRI,
      handleSwitch: props.handleSwitch,
    },
    setShowAlerts: setShowAlerts,
    startDate: props.startDate,
    endDate: props.endDate,
  });

  useEffect(()=>{
    const init = async () => { 
      let data = await presenter.getSpfeStep4(); 
      props.setStep4(data)
    }
    if(props.step4 === undefined) init()
  },[props.step4, props.switchForm]);

  useEffect(()=>{
    const init = async () => { 
      let data = await presenter.getSpfeStep4MRI(); 
      props.setStep4MRI(data)
    }
    if(props.step4MRI === undefined) init()
  },[props.step4MRI, props.switchForm]);

  useEffect(() => {
    if(props.step4 !== undefined) presenter.initializeStep4Objetives(props.step4, props.index);
  }, [props.step4]);

  useEffect(() => {
    getMriData()
  }, [props.step4MRI, props.startDate, props.dataColumns, props.endDate, props.step1, showAlerts])

  useEffect(() => {
    if (!Utilities.isNullEmptyObject(objetives) && props.step4 !== undefined) getStepData()
  }, [props.step4, props.startDate, props.dataColumns, objetives, props.startDate, props.endDate, showAlerts])

  const getMriData = () => {
    setMriData(
      <Col xs="12" sm="12" md="12" xl="12">
        <MRIIndicators handleSwitch={props.handleSwitch} showAlerts={showAlerts} alertEndDate={props.alertEndDate} subventionCodeId={props.subventionCodeId} endDate={props.endDate} step1={props.step1} tabIndex={props.index} dataColumns={props.dataColumns} startDate={props.startDate} stepMriData={props.step4MRI} setStep4MRI={props.setStep4MRI} />
      </Col>
    )
  }

  const getStepData = () => {
    const accTitles = objetives.map((objetive: any, index: number) => {
      const key = String.Format("obj_T{0}_O{1}", props.index, index);
      return (
        <div key={"container" + key}>
          <ListGroup style={{ width: "100%" }}>
            <ListGroupItem
              key={key}
              style={{ width: "100%" }}
              onClick={() => presenter.openObjetive(index)}
            >
              {objetive.genericInfo?.PProaObjetivo
                ? objetive.genericInfo.PProaObjetivo
                : String.Format("{0}", index + 1)}
            </ListGroupItem>
          </ListGroup>
          <Collapse isOpen={objetive.open}>
            <Card>
              <CardBody>
                <GeneralData
                  handleSwitch={props.handleSwitch}
                  alertEndDate={props.alertEndDate}
                  showAlerts={showAlerts} 
                  subventionCodeId={props.subventionCodeId}
                  endDate={props.endDate} 
                  tabIndex={props.index}
                  objIndex={index}
                  dataColumns={props.dataColumns}
                  stepData={props.step4}
                  setStepData={props.setStep4}
                  startDate={props.startDate}
                  readOnly={readOnly}
                ></GeneralData>
              </CardBody>
            </Card>
          </Collapse>
        </div>
      );
    });
    
    setStepData(
      <Row xs={1} sm={1} md={1} xl={1} >
        <Col> {accTitles} </Col>
      </Row>
    )
  }
  
  const adaptacionIndicadoresMRI = () => {
    return (
      <Row>
        <Col xs="12" sm="12" md="12" xl="12">
          <AEATitle
            id={"proaFEAdaptaciónIndicadoresMRI"}
            text={presenter.currentLabels.get("proaFEAdaptaciónIndicadoresMRI")}
            tooltip={presenter.currentLabels.get("proaFEAdaptaciónIndicadoresMRI")}
            placement={"auto"}
          ></AEATitle>
        </Col>
        {!!mriData && mriData}
      </Row>
    );
  };

  const header = () => {
    return (
      <Row>
        <Col xs="12" sm="12" md="8" xl="8">
          <AEATitle
            id={"proaFEObjetivosEspecíficos"}
            text={presenter.currentLabels.get("proaFEObjetivosEspecíficos")}
            tooltip={presenter.currentLabels.get("proaFEObjetivosEspecíficos")}
            placement={"auto"}
          ></AEATitle>
        </Col>
        {!readOnly ? (
          <Col xs="12" sm="12" md="4" xl="4">
            <div className={styles.containerButtons}>
              <Button onClick={presenter.addNewObjetive}>
                {presenter.currentLabels.get("NuevoObjetivo")}
              </Button>
            </div>
          </Col>
        ) : (
          <div></div>
        )}
      </Row>
    );
  };

  if (Utilities.isNullEmptyObject(props.step1) && !!props.getWarningMsg) return (<> {props.getWarningMsg()} </>) 

  return (
    <Container fluid={true}>
      <Form>
        <ValidationGroup ref={(ref) => (validationGroup = ref)}>
          {adaptacionIndicadoresMRI()}
          <br />
          <br />
          <div style={{position: 'relative', minHeight: '100px', width: '100%'}}>
            <Loader loading={!objetives} currentData={!!objetives} />
            {header()}
            <br />
            <br />
            {(!!stepData && props.step4 !== undefined) && stepData}
            <br />
            <br />
          </div>
          {/* {!readOnly ? (
            <Button
              className={styles.saveButton}
              disabled={props.step4MRI === undefined || props.step4 === undefined}
              onClick={(e) => {
                e.preventDefault();
                setTimeout(() => {
                if (validationGroup.instance.validate().isValid) {
                  presenter.saveStep4(props.index);
                } else {
                  Utilities.notifyError(presenter.currentLabels.get("Datos invalidos"));
                }
              },500)}}
            >
              {presenter.currentLabels.get("Guardar")}
            </Button>
          ) : null} */}
          <Button
            onClick={(e) => { context.history.push("/proyecta/proa"); }}
          >
            {presenter.currentLabels.get("Cancelar")}{" "}
          </Button>
        </ValidationGroup>
      </Form>
    </Container>
  );
};

export default ObjetivesFE;
